import { URL } from 'url';

export default function GetAbsolutePath(path: string) {
  if (process.browser && window && URL) {
    const url = new URL(path, window.location.href);
    return url.href;
  }
  return path;
}
